import { z as z$1 } from "zod";

// src/models/ids.ts
/**
* Helper function to create a Zod schema for a Flavor-typed ID field.
* Pass the Flavor type as a generic parameter - the transformation is handled internally.
*
* @returns Zod schema that validates and transforms strings to the specified Flavor type
*
* @example
* ```typescript
* const schema = z.object({
*   id: zodFlavorId<ClassId>(),
*   name: z.string(),
* });
* ```
*/
function zodFlavorId() {
	return z$1.string().transform((val) => val);
}
const zodTransformStripeFirestoreProductIdOrNotSelected = (val) => val;
/** Signup plan step: paid product id, not chosen yet, or explicit free trial (no checkout). */
const SIGNUP_PLAN_SELECTION_FREE_TRIAL = "free-trial";
const zodTransformSignupPlanSelection = (val) => {
	if (val === "not-selected" || val === "free-trial") return val;
	return val;
};

export { SIGNUP_PLAN_SELECTION_FREE_TRIAL, zodFlavorId, zodTransformSignupPlanSelection, zodTransformStripeFirestoreProductIdOrNotSelected };
//# sourceMappingURL=ids.mjs.map